module.exports = __webpack_public_path__ + "static/003-slideshow-efdc4cdd0f13d29b6fd3d005403c2e68.jpg";